import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.grey[100],
    borderRadius: 4,
    marginTop: 20,
    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
    padding: '30px 10px 40px 10px',
    gap: 40
  },
  eachRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 40
  },
  buttonContainers: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  },
  resetButton: {
    color: theme.palette.grey[700]
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  }
}))

export default useStyles
